import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";


const FinancialCrime = () => {
    const screenId="RevenueViaFees"
    const formatters = Formatters()
    const charts = {
        trxValueAndCountPerKYCLevel: {},
        cashAndOtherSpends: {},
        onboardedWithFullVsSimplifiedKYC: {}

    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default FinancialCrime
